import { render } from "./noticeNews.vue?vue&type=template&id=4929873a&scoped=true"
import script from "./noticeNews.vue?vue&type=script&lang=js"
export * from "./noticeNews.vue?vue&type=script&lang=js"

import "./noticeNews.vue?vue&type=style&index=0&id=4929873a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4929873a"]])

export default __exports__